import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, NgModule } from '@angular/core';
import { WindowService } from '../window.service';
import { bounce } from './arrow-link-animation';

@Component({
  selector: 'lp2-arrow-link',
  template: `<a [ngClass]="{ compact: isCompact }" (click)="redirectToLink()"> {{ text }} » </a>`,
  styleUrls: ['./arrow-link.component.scss'],
  animations: [bounce],
})
export class ArrowLinkComponent {
  @Input() text = '';
  @Input() linksTo = '';
  @Input() isCompact: boolean;
  animateTimes = 0;

  constructor(public el: ElementRef, private windowService: WindowService) {}

  @HostListener('mouseenter')
  onmouseenter() {
    this.continueAnimation();
  }

  continueAnimation() {
    this.animateTimes = this.animateTimes + 1;
  }

  redirectToLink() {
    if (!this.linksTo) {
      return;
    }
    this.windowService.redirectToUrl(this.linksTo);
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [ArrowLinkComponent],
  exports: [ArrowLinkComponent],
})
export class ArrowLinkModule {}



// WEBPACK FOOTER //
// ./ts/app/shared/arrow-link/arrow-link.component.ts